import axios from "axios";
import { axiosUser, axiosAdmin, axiosUserSMSAPI, axiosUserWA, axiosUserEmail, axiosUserCall } from "config/axios.config";
import authSvc from "./authSvc";

const APPLICATION_URL = "/application";
const UPLOAD_URL = `/upload`;
const SMS_URL = `/sms/record`;
const SMS_URL_OTP = `/otp/record`;
const WA_URL = `/wa-records`;
const EMAIL_URL = `/email/report`;
const CALL_URL = `/call/report`;
const CALL_OTP_URL = `/otp-call/report`;

let BASE_URL_CALL_REPORT = '';
let BASE_URL_WA_REPORT = '';
let BASE_URL_EMAIL_REPORT = '';
let BASE_URL_SMS_REPORT = '';
let BASE_URL_MEAPI = '';

if (localStorage.getItem('current_set') === 'staging') {
  BASE_URL_CALL_REPORT = process.env.REACT_APP_CALL_REPORT_STAGING
  BASE_URL_WA_REPORT = process.env.REACT_APP_WA_REPORT_STAGING
  BASE_URL_EMAIL_REPORT = process.env.REACT_APP_EMAIL_REPORT_STAGING
  BASE_URL_SMS_REPORT = process.env.REACT_APP_SMS_REPORT_STAGING
  BASE_URL_MEAPI = process.env.REACT_APP_MEAPI_STAGING
} else {
  BASE_URL_CALL_REPORT = process.env.REACT_APP_CALL_RECORD
  BASE_URL_WA_REPORT = process.env.REACT_APP_WA_RECORD
  BASE_URL_EMAIL_REPORT = process.env.REACT_APP_EMAIL_RECORD
  BASE_URL_SMS_REPORT = process.env.REACT_APP_SMS_REPORT_RATE
  BASE_URL_MEAPI = process.env.REACT_APP_DASHBOARD_DOC_URL
}

const configHeader = (appId) => (
  {'x-application-key': `${appId}`,'Content-Type': 'application/json;charset=UTF-8', "Access-Control-Allow-Origin": "*" }
)

const userData = authSvc.currentUser();
console.log('user', userData)
const applicationSvc = {
  getAll: async () => {
    const userId = authSvc.currentUser()?.user?.id;
    const payloadData = {
      "channel_id": [],
      "search": "",
      "page": 1,
      "limit": 10,
      filtered: `[{"id":"user","value":"${userId}"}]`
  }
    const response = await axiosUser.post(`${APPLICATION_URL}`,payloadData);
    localStorage.setItem('app_id', response?.data?.data?.data[0]?._id)
    return response?.data;
  },
  getAllApplication: async (body) => {
    const response = await axiosUser.post(`${APPLICATION_URL}`, body);
    localStorage.setItem('app_id', response?.data?.data?.data[0]?._id)
    return response;
  },
  getById: async (id) => {
    const response = await axiosUser.get(`${APPLICATION_URL}/${id}`);
    return response;
  },
  create: async (body) => {
    const response = await axiosUser.post(`${APPLICATION_URL}`, body);
    return response;
  },
  update: async (id, body) => {
    const response = await axiosUser.put(`${APPLICATION_URL}/${id}`, body);
    return response;
  },
  delete: async (id) => {
    const response = await axiosUser.delete(`${APPLICATION_URL}/${id}`);
    return response;
  },
  upload: async (image) => {
    const formData = new FormData();
    formData.append("image", image);
    const response = await axiosAdmin.post(UPLOAD_URL, formData, {
      "Content-Type": "multipart/form-data",
    });
    return response;
  },
  generatePem: async (applicationId) => {
    const data = {
      application: applicationId
    }
    const URL = "https://api.ocatelkom.co.id/auth/rsa/generate-token";
    const response = await axios.post(URL, data, {
      'content-type': 'application/json'
    });
    return response;
  },

  generateSmsRecord: async (appId, body) => {
    const response = await axiosUserSMSAPI.post(`${SMS_URL}`, body, { headers: configHeader(appId) });
    return response;
  },

  generateSWaRecord: async (appId, body) => {
    const response = await axiosUserWA.post(`${WA_URL}`, body, { headers: configHeader(appId) });
    return response;
  },

  generateEmailRecord: async (appId, body) => {
    const response = await axiosUserEmail.post(`${EMAIL_URL}`, body, { headers: configHeader(appId) });
    return response;
  },

  generateCallRecord: async (appId, body) => {
    const response = await axiosUserCall.post(`${CALL_URL}`, body, { headers: configHeader(appId) });
    return response;
  },

  generateCallOtpRecord: async (appId, body) => {
    const response = await axiosUserCall.post(`${CALL_OTP_URL}`, body, { headers: configHeader(appId) });
    return response;
  },

  generateSmsOTP: async (appId, body) => {
    const response = await axiosUserSMSAPI.post(`${SMS_URL_OTP}`, body, { headers: configHeader(appId) });
    return response;
  },

  generateSMSDownload: async (appId, params) => {
    const response = await axiosUserSMSAPI.get(`/sms/record-download?${params}`, { headers: configHeader(appId) });
    return response;
  },

  monitoringSMSDownloadBuffer: async (appId, params) => {
    const user = await axios.get(`${BASE_URL_SMS_REPORT}/sms/record-download?${params}`,
      {
        responseType: "blob",
        headers: {
          'x-application-key': `${appId}`, "Access-Control-Allow-Origin": "*"
        }
      });
    return user;
  },

  generateSMSOTPDownload: async (appId, params) => {
    const response = await axiosUserSMSAPI.get(`/sms/record-download?${params}`, { headers: configHeader(appId) });
    return response;
  },

  monitoringSMSOTPDownloadBuffer: async (appId, params) => {
    const user = await axios.get(`${BASE_URL_SMS_REPORT}/sms/record-download?${params}`,
      {
        responseType: "blob",
        headers: {
          'x-application-key': `${appId}`, "Access-Control-Allow-Origin": "*"
        }
      });
    return user;
  },

  monitoringCallDownload: async (appId, params) => {
    const user = await axios.get(`${BASE_URL_CALL_REPORT}/call/report/download?${params}`, { headers: configHeader(appId) });
    return user;
  },

  monitoringCallDownloadBuffer: async (appId, params) => {
    const user = await axios.get(`${BASE_URL_CALL_REPORT}/call/report/download?${params}`,
      {
        responseType: "blob",
        headers: {
          'x-application-key': `${appId}`, "Access-Control-Allow-Origin": "*"
        }
      });
    return user;
  },

  monitoringWADownload: async (appId, params) => {
    const user = await axios.get(`${BASE_URL_WA_REPORT}/wa-records/download?${params}`, { headers: configHeader(appId) });
    return user;
  },

  monitoringWADownloadBuffer: async (appId, params) => {
    const user = await axios.get(`${BASE_URL_WA_REPORT}/wa-records/download?${params}`,
      {
        responseType: "blob",
        headers: {
          'x-application-key': `${appId}`, "Access-Control-Allow-Origin": "*"
        }
      });
    return user;
  },

  monitoringEmailDownload: async (appId, params) => {
    const user = await axios.get(`${BASE_URL_EMAIL_REPORT}/email/report/download?${params}`, { headers: configHeader(appId) });
    return user;
  },

  monitoringEmailDownloadBuffer: async (appId, params) => {
    const user = await axios.get(`${BASE_URL_EMAIL_REPORT}/email/report/download?${params}`,
      {
        responseType: "blob",
        headers: {
          'x-application-key': `${appId}`, "Access-Control-Allow-Origin": "*"
        }
      });
    return user;
  },
  getRemainingQuota: async (appId) => {
    const user = await axios.get(`${BASE_URL_MEAPI}/application/billing/${appId}`, 
    { headers: {'Authorization': `Bearer ${userData.token}`} });
    return user;
  },
  getBalanceQuota: async (appId) => {
    const user = await axios.get(`${BASE_URL_MEAPI}/application/check/balance-quota/${appId}`, 
    { headers: {'Authorization': `Bearer ${userData.token}`} });
    return user;
  },
  sendNotifBalanceQuota: async (appId, reqBody) => {
    const user = await axios.post(`${BASE_URL_MEAPI}/application/send-notif/balance-remaining/${appId}`, 
    reqBody,
    { headers: {'Authorization': `Bearer ${userData.token}`} });
    return user;
  },
  getSettingBalanceQuota: async (userId) => {
    const user = await axios.get(`${BASE_URL_MEAPI}/setting/balance-quota/${userId}`, 
    { headers: {'Authorization': `Bearer ${userData.token}`} });
    return user;
  } ,
  updateSettingBalanceQuota: async (userId, reqBody) => {
    const user = await axios.put(`${BASE_URL_MEAPI}/setting/balance-quota/${userId}`,
    reqBody, 
    { headers: {'Authorization': `Bearer ${userData.token}`} });
    return user;
  },

  generateToken: async (userId, reqBody) => {
    const response = await axios.post(`${BASE_URL_MEAPI}/channel/generate/access-token/${userId}`, 
      reqBody, 
      { headers: {
        'Authorization': `Bearer ${userData.token}`,
        'content-type': 'application/json'
      } }
    );

    return response;
  },
};

export default applicationSvc;
